import { fadeIn, fadeOut } from "@/utils/utils";

export default class DesktopGallery {
  // singleton pattern

  _id;
  _rootDivSelector;
  _srcObjectArray;
  _activatingBtnSelectors;
  _currentSrcIndex;
  _data;
  _state;
  _totalImages;
  _stopPropSelectors;
  _youtubeUrl = "https://www.youtube.com/embed/";
  _leftPercValues = {
    left: -50,
    main: 50,
    right: 150
  };

  constructor(id, rootDivSelector, srcObjectArray, activatingBtnSelectors, options = {}) {
    if (DesktopGallery.singleton) {
      return DesktopGallery.singleton;
    }
    this._id = id;
    this._rootDivSelector = rootDivSelector;
    this._srcObjectArray = srcObjectArray;
    this._activatingBtnSelectors = activatingBtnSelectors;
    this._currentSrcIndex = 0;
    this._data = {
      startActionTimestamp: 0,
      endActionTimestamp: 0,
      animationSpeed: options.animationSpeed || 350,
      quickAnimationSpeed: options.quickAnimationSpeed || 150
    };
    this._state = {
      isAnimating: false,
      isDragged: false
    };
    this._stopPropSelectors = [".top-text", ".gallery-rounded-btn", ".gallery-desktop-img", ".gallery-bottom-btn"];
    DesktopGallery.singleton = this;
    return DesktopGallery.singleton;
  }

  // getters

  get id() {
    return this._id;
  }
  get rootDivSelector() {
    return this._rootDivSelector;
  }
  get srcObjectArray() {
    return this._srcObjectArray;
  }
  get activatingBtnSelector() {
    return this._activatingBtnSelectors;
  }
  get currentSrcIndex() {
    return this._currentSrcIndex;
  }
  get isAnimating() {
    return this._state.isAnimating;
  }

  // setters

  set srcObjectArray(newArray) {
    // do some refreshing here
    this._srcObjectArray = newArray;
    if (this._srcObjectArray.length > this._currentSrcIndex) {
      this._setSlides(0);
    } else {
      this._setSlides(this._currentSrcIndex);
    }
    this._setTotalImages();
  }
  set currentSrcIndex(newIndex) {
    // add switching to the set image animation here
    this._currentSrcIndex = newIndex;
    this._setSlides(newIndex);
  }

  // private methods

  _getTemplate() {
    return `
        <div class="gallery-desktop-top col-12 d-flex mt-xxl-5">
            <!-- <div class="col-2 col-lg-1"></div> -->
            <div class="col-8 col-lg-11 d-flex flex-row nowrap justify-content-between align-items-center">
                <div class="top-text text-white">
                    <span class="title-3 main-top-text">${window.lihe.name}</span>
                    <span>&bull;</span>
                    <span class="weight-600 font-16 current-image"></span>
                    <span class="weight-600 font-16">/</span>
                    <span class="weight-600 font-16 total-images"></span><span> ${window.content.gallery_photos}</span>
                </div>
            </div>
            <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center">
                <button
                    class="gallery-rounded-btn text-white gallery-desktop-cls cursor-pointer rounded-circle d-flex align-items-center justify-content-center">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 18L18 6M6 6L18 18" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
            </div>
        </div>
        <div class="gallery-desktop-middle col-12 d-flex">
            <div class="col-2 col-lg-1 d-flex align-items-center">
                <button
                    class="gallery-rounded-btn text-white cursor-pointer rounded-circle d-flex align-items-center justify-content-center slide-left-btn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 19L8 12L15 5" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <div class="col-8 col-lg-10 d-flex align-items-center justify-content-center">
                <div
                    class="w-100 h-100 d-flex align-items-center justify-content-center position-relative">
                    <div style="border-radius: 10px; max-width: 100%; left: ${this._leftPercValues.left}%; height: 100%; width: 100%; opacity: 0;" class="position-absolute gallery-desktop-slide-wrapper gallery-desktop-left-slide-wrapper d-flex align-items-center justify-content-center">

                        <img style="border-radius: 10px; display:none; max-height: 100%; max-width: 100%;" src=""
                            alt="${lihe.name} - ${lihe.station}"
                            class="gallery-desktop-img gallery-desktop-left-img " />
                        <iframe type="text/html" width="640" height="360" style="display:none;" class="gallery-desktop-iframe gallery-desktop-left-iframe" src=""></iframe>

                    </div>
                    <div style="border-radius: 10px; max-width: 100%; left: ${this._leftPercValues.main}%; height: 100%; width: 100%; opacity: 1; touch-action: manipulation;" class="position-absolute gallery-desktop-slide-wrapper gallery-desktop-main-slide-wrapper d-flex align-items-center justify-content-center">

                        <img style="border-radius: 10px; display:none; max-height: 100%; max-width: 100%;" src=""
                            alt="${lihe.name} - ${lihe.station}"
                            class="gallery-desktop-img gallery-desktop-main-img" />
                        <iframe type="text/html" width="640" height="360" style="display:none;" class="gallery-desktop-iframe gallery-desktop-main-iframe" src=""></iframe>

                    </div>
                    <div style="border-radius: 10px; max-width: 100%; left: ${this._leftPercValues.right}%; height: 100%; width: 100%; opacity: 0;" class="position-absolute gallery-desktop-slide-wrapper gallery-desktop-right-slide-wrapper d-flex align-items-center justify-content-center">

                        <img style="border-radius: 10px; display:none; max-height: 100%; max-width: 100%;" src="" 
                            alt="${lihe.name} - ${lihe.station}"
                            class="gallery-desktop-img gallery-desktop-right-img" />
                        <iframe type="text/html" width="640" height="360" style="display:none;" class="gallery-desktop-iframe gallery-desktop-right-iframe" src=""></iframe>

                    </div>
                </div>
            </div>
            <div class="col-2 col-lg-1 d-flex align-items-center justify-content-center">
                <button
                    class="gallery-rounded-btn text-white cursor-pointer rounded-circle d-flex align-items-center justify-content-center slide-right-btn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5L16 12L9 19" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
            </div>
        </div>
        <div class="gallery-desktop-bottom col-12 d-flex">
            <div class="col-2 col-lg-1"></div>
            <div class="col-8 col-lg-10 d-flex flex-row nowrap align-items-center justify-content-center">
                <!-- <div class="weight-600 font-16 gallery-bottom-buttons text-white d-flex flex-row nowrap">
                    <div class="active gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                    <div class="gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                    <div class="gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                    <div class="gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                    <div class="gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                    <div class="gallery-bottom-btn cursor-pointer p-3 mx-2">Button</div>
                </div> -->
            </div>
            <div class="col-2 col-lg-1"></div>
        </div>
        `;
  }

  _getRootDiv() {
    return document.querySelector(this._rootDivSelector);
  }

  _setTotalImages() {
    this._totalImages = this._srcObjectArray.length;
    this._getRootDiv().querySelector(".total-images").innerHTML = this._totalImages;
  }

  _setCurrentImage() {
    this._getRootDiv().querySelector(".current-image").innerHTML = this._currentSrcIndex + 1;
  }

  _getOverlay() {
    return document.querySelector("#tf-overlay");
  }

  _getSlide(side = "main") {
    if (!["left", "right", "main"].includes(side)) throw new Error('side must be "left", "right" or "main"');
    return this._getRootDiv().querySelector(`.gallery-desktop-${side}-slide-wrapper`);
  }

  _getClsBtn() {
    return this._getRootDiv().querySelector(".gallery-desktop-cls");
  }

  _getControlBtns() {
    const joinedSelector = this._activatingBtnSelectors.join(", ");
    return Array.from(document.querySelectorAll(joinedSelector));
  }

  _getControlBtn(side) {
    if (!["left", "right"].includes(side)) throw new Error('side must be "left" or "right"');
    return this._getRootDiv().querySelector(`.slide-${side}-btn`);
  }

  _injectHTML() {
    this._getRootDiv().innerHTML = "";
    this._getRootDiv().insertAdjacentHTML("beforeend", this._getTemplate());
  }

  _displaySlider() {
    document.body.classList.add("overflow-hidden");
    fadeIn(this._getOverlay());
    fadeIn(this._getRootDiv(), "grid");
  }

  _hideSlider() {
    document.body.classList.remove("overflow-hidden");
    this._getRootDiv()
      .querySelectorAll("iframe")
      .forEach((iframe) => {
        iframe.src = "";
      });
    fadeOut(this._getOverlay());
    fadeOut(this._getRootDiv());
  }

  _setSlideSrc(type, index) {
    const wrapper = this._getSlide(type);
    const srcObj = this._srcObjectArray[index];

    const imgElem = wrapper.querySelector("img");
    const iframeElem = wrapper.querySelector("iframe");

    if (srcObj.type === "image") {
      imgElem.src = srcObj.imgXL || srcObj.imgLarge || srcObj.imgMedium || srcObj.imgSmall || srcObj.img;
      iframeElem.src = "";
      imgElem.style.display = "block";
      iframeElem.style.display = "none";
    } else {
      imgElem.src = "";
      iframeElem.src = type === "main" ? this._youtubeUrl + srcObj.src : "";
      imgElem.style.display = "none";
      iframeElem.style.display = "block";
    }
  }

  _setSlides(mainIndex) {
    if (this._srcObjectArray.length === 0) return;

    this._currentSrcIndex = mainIndex;

    this._setSlideSrc("left", this._getNextSrcIndex(mainIndex, "left"));
    this._setSlideSrc("main", mainIndex);
    this._setSlideSrc("right", this._getNextSrcIndex(mainIndex, "right"));

    this._getSlide("left").style.opacity = 0;
    this._getSlide("main").style.opacity = 1;
    this._getSlide("right").style.opacity = 0;

    this._getSlide("left").style.left = `${this._leftPercValues.left}%`;
    this._getSlide("main").style.left = `${this._leftPercValues.main}%`;
    this._getSlide("right").style.left = `${this._leftPercValues.right}%`;
  }

  _getNextSrcIndex(index, direction = "main") {
    let diff;
    if (direction === "left") {
      diff = -1;
    } else if (direction === "right") {
      diff = 1;
    } else {
      return index;
    }
    const preliminaryNextSrcIndex = index + diff;
    let finalNextSrcIndex = preliminaryNextSrcIndex;
    if (preliminaryNextSrcIndex < 0) {
      finalNextSrcIndex = this._srcObjectArray.length - 1;
    }
    if (preliminaryNextSrcIndex >= this._srcObjectArray.length) {
      finalNextSrcIndex = 0;
    }
    return finalNextSrcIndex;
  }

  _isNeedQuickAnimation() {
    return this._data.endActionTimestamp - this._data.startActionTimestamp <= this._data.animationSpeed;
  }

  _getDirection() {
    // if drag wasn't quick - allow for return to main slide (with multipliers)
    const quick = this._isNeedQuickAnimation();
    const leftMultiplier = quick ? 1 : 0.5;
    const rightMultiplier = quick ? 1 : 1.5;

    const regex = /(-?\d+)%/;
    const currentMainLeftString = this._getSlide("main").style.left;
    const currentMainLeft = currentMainLeftString.match(regex)[1];
    const distanceBetweenSlides = this._leftPercValues.main - this._leftPercValues.left;

    // ignore tiny movements, only react to > 0.5% of image width
    const percScrolled = (currentMainLeft - distanceBetweenSlides) / distanceBetweenSlides;
    if (percScrolled < 0.005 && percScrolled > -1 * 0.005) return "main";

    if (currentMainLeft < (distanceBetweenSlides / 2) * leftMultiplier) {
      return "right";
    } else if (currentMainLeft > (distanceBetweenSlides / 2) * rightMultiplier) {
      return "left";
    } else {
      return "main";
    }
  }

  _animate(direction = undefined) {
    direction = direction ?? this._getDirection();

    try {
      if (this._state.isAnimating) return;
      this._state.isAnimating = true;

      const leftSlide = this._getSlide("left");
      const mainSlide = this._getSlide("main");
      const rightSlide = this._getSlide("right");

      const newMainSrcIndex = this._getNextSrcIndex(this._currentSrcIndex, direction);

      if (leftSlide.style.left === `${this._leftPercValues.main}%` || rightSlide.style.left === `${this._leftPercValues.main}%`) {
        this._setSlides(newMainSrcIndex);
        this._setCurrentImage();
        setTimeout(() => {
          this._state.isAnimating = false;
        }, 100);
        return;
      }

      // action
      setTimeout(() => {
        leftSlide.classList.add("animate");
        mainSlide.classList.add("animate");
        rightSlide.classList.add("animate");

        leftSlide.style.opacity = direction === "left" ? 1 : 0;
        mainSlide.style.opacity = direction === "main" ? 1 : 0;
        rightSlide.style.opacity = direction === "right" ? 1 : 0;

        if (direction === "left") {
          mainSlide.style.left = `${this._leftPercValues.right}%`;
          leftSlide.style.left = `${this._leftPercValues.main}%`;
        } else if (direction === "right") {
          mainSlide.style.left = `${this._leftPercValues.left}%`;
          rightSlide.style.left = `${this._leftPercValues.main}%`;
        } else {
          mainSlide.style.left = `${this._leftPercValues.main}%`;
          rightSlide.style.left = `${this._leftPercValues.right}%`;
          leftSlide.style.left = `${this._leftPercValues.left}%`;
        }
      }, 0);

      // cleanup
      const transitionEndFunc = () => {
        this._state.isAnimating = false;
        leftSlide.classList.remove("animate");
        mainSlide.classList.remove("animate");
        rightSlide.classList.remove("animate");
        this._setSlides(newMainSrcIndex);
        this._setCurrentImage();
        mainSlide.removeEventListener("transitionend", transitionEndFunc);
      };
      mainSlide.addEventListener("transitionend", transitionEndFunc, { passive: true });
    } catch (err) {
      console.error(err);
    }
  }

  _setListeners() {
    const leftSlide = this._getSlide("left");
    const mainSlide = this._getSlide("main");
    const rightSlide = this._getSlide("right");
    [this._getRootDiv(), this._getOverlay(), this._getClsBtn(), leftSlide,
      mainSlide,
      rightSlide].forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.stopPropagation();
        if (this._state.isDragged || this._state.isAnimating) return;
        this._hideSlider();
      });
    });



    // function to get X position of event (different for touch events)
    const getX = (ev) => {
      if (["touchstart", "touchmove", "touchend"].includes(ev.type)) {
        return ev.touches[0].pageX;
      } else {
        return ev.pageX;
      }
    };

    const getPerc = (int) => {
      const newVal = this._leftPercValues.main + int;
      if (newVal < this._leftPercValues.left) {
        return this._leftPercValues.left;
      } else if (newVal > this._leftPercValues.right) {
        return this._leftPercValues.right;
      } else {
        return newVal;
      }
    };

    const getOpacity = (mainPerc, side) => {
      if (!["left", "main", "right"].includes(side)) throw new Error('side must be "left", "right" or "main"');
      let mainOpacity;
      if (mainPerc > this._leftPercValues.main) {
        mainOpacity = 1 - (mainPerc - this._leftPercValues.main) / this._leftPercValues.main;
      } else if (mainPerc <= this._leftPercValues.main) {
        mainOpacity = 1 - (this._leftPercValues.main - mainPerc) / this._leftPercValues.main;
      }
      switch (side) {
        case "left":
          return 1 - mainOpacity > 1 ? 1 : 1 - mainOpacity;
        case "right":
          return 1 - mainOpacity > 1 ? 1 : 1 - mainOpacity;
        default:
          return mainOpacity < 0 ? 0 : mainOpacity;
      }
    };

    // set slider manipulation events
    [["mousedown", "mousemove", "mouseup"]].forEach(([startEventString, moveEventString, endEventString]) => {
      // start event listener
      mainSlide.addEventListener(
        startEventString,
        (startEvent) => {
          this._state.isDragged = true;

          const currentTimestamp = Date.now();
          // const rootWidth = this._getRootWidth()
          this._data.startActionTimestamp = currentTimestamp;

          const initialX = getX(startEvent);
          let previousX = initialX; // taking previousX instead of CurrentX due to some weird behavior on last drag event (when it boops back into place)
          let currentX = initialX;

          // move event handler
          const moveFunc = (moveEvent) => {
            previousX = currentX;
            currentX = getX(moveEvent);
            const distanceTraveled = previousX - initialX;
            const leftPerc = getPerc(parseInt(distanceTraveled)) - (this._leftPercValues.main - this._leftPercValues.left);
            const mainPerc = getPerc(parseInt(distanceTraveled));
            const rightPerc = getPerc(parseInt(distanceTraveled)) + (this._leftPercValues.right - this._leftPercValues.main);

            leftSlide.style.left = `${leftPerc}%`;
            mainSlide.style.left = `${mainPerc}%`;
            rightSlide.style.left = `${rightPerc}%`;

            leftSlide.style.opacity = getOpacity(mainPerc, "left");
            mainSlide.style.opacity = getOpacity(mainPerc, "main");
            rightSlide.style.opacity = getOpacity(mainPerc, "right");
          };
          // end event handler
          const endFunc = async (endEvent) => {
            document.removeEventListener(moveEventString, moveFunc);
            document.removeEventListener(endEventString, endFunc);

            this._data.endActionTimestamp = Date.now();
            this._state.isDragged = false;

            if (startEvent.pageX !== endEvent.pageX) {
              await this._animate();
            }

            // this._displayControlsForCurrentSlide()
          };

          document.addEventListener(moveEventString, moveFunc, { passive: true });
          document.addEventListener(endEventString, endFunc, { passive: true });
        },
        { passive: true }
      );
    });

    this._getSlide("main").addEventListener("transitionstart", () => (this._data.isAnimating = true));
    this._getSlide("main").addEventListener("transitionend", () => (this._data.isAnimating = false));

    ["dragstart", "drag"].forEach((ev) => {
      leftSlide.addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
      mainSlide.addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
      rightSlide.addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
      leftSlide.querySelector("img").addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
      mainSlide.querySelector("img").addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
      rightSlide.querySelector("img").addEventListener(ev, (e) => {
        e.preventDefault();
        return false;
      });
    });

    this._getControlBtns().forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (this._state.isAnimating || this._state.isDragged) return;

        if (e.target.hasAttribute("data-img-index")) {
          const requiredSrcIndex = parseInt(e.target.getAttribute("data-img-index"));
          if (this._srcObjectArray[2].type === "video_youtube" && requiredSrcIndex >= 2) {
            this._setSlides(requiredSrcIndex + 1);
          } else {
            this._setSlides(requiredSrcIndex);
          }
        }
        this._displaySlider();
        this._setCurrentImage();
      });
    });

    this._getControlBtn("left").addEventListener("click", () => this.triggerSlide("left"));
    this._getControlBtn("right").addEventListener("click", () => this.triggerSlide("right"));

    this._stopPropSelectors.forEach((selector) => {
      Array.from(this._getRootDiv().querySelectorAll(selector)).forEach((elem) => {
        elem.addEventListener("click", (e) => e.stopPropagation());
      });
    });
  }

  // public methods

  init() {
    this._injectHTML();
    this._setListeners();
    this._setSlides(this._currentSrcIndex);
    this._setTotalImages();
    this._setCurrentImage();
  }

  triggerSlide(direction) {
    this._animate(direction);
  }
}
